import React from 'react'
import { Button } from 'antd'
import './ButtonMain.scss'

export default function ButtonMain (props) {
  // eslint-disable-next-line react/prop-types
  const { buttonType, ...otherProps } = props
  return (
    <>
    {
      buttonType === 'main' ? <Button className="button-submit" type="link" {...otherProps} ></Button> : <Button className="button-resend" type="link" {...otherProps} ></Button>
    }
    </>
  )
}
